<script>
    export let keyItems;
</script>

<p class="table-label">Finding</p>
<div class="table-key">
    {#each Object.entries(keyItems) as [key, item]}
    <div class="key-item">
        <div class="img-holder filter-button">
            <img id={item.imgId} alt={item.imgAlt} src={item.imgUrl} />
        </div>
        <p>{item.description}</p>
    </div>
    {/each}                  
</div>